module.exports = __webpack_public_path__ + "static/media/pointer.a4bc7d5f.svg";